import TitleBlock from '@anm/components/TitleBlock';
import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import { DASHBOARD_CONTENT_WRAPPER_WIDTH, DASHBOARD_NAVBAR_WIDTH } from '@anm/styles/constants';
import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';
import { VideoSizes } from '@anm/hosting-player';
import { playerContainerCommonStyles } from './PlayerBlock/Wrapper';

type LandingFrameWrapperProps = {
  iframeScale?: number;
  iframeWidth?: number;
  iframeHeight?: number;
};

type RightPanelProps = {
  isLandingScreen: boolean;
  isFullSizePreview?: boolean;
};

const wrapperOnTablet = media.tablet<{ isLandingScreen: boolean }>`
    max-width: 100%;
    align-self: center;
    width: 100%;
    order: ${({ isLandingScreen }) => (isLandingScreen ? 2 : 1)};
`;

const fullSizePreviewStyles = css`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 6;
  max-width: unset;
`;

const RightPanelWrapper = styled.div<RightPanelProps>`
  flex-grow: 1;
  background: ${({ isLandingScreen }) => (isLandingScreen ? '#F5F7FA' : '#fff')};
  text-align: center;
  max-width: calc(100% - ${DASHBOARD_CONTENT_WRAPPER_WIDTH}px - ${DASHBOARD_NAVBAR_WIDTH}px);
  padding: ${({ isLandingScreen }) => (!isLandingScreen ? '38px 20px 0' : 0)};

  ${({ isFullSizePreview, isLandingScreen }) => isLandingScreen && isFullSizePreview && fullSizePreviewStyles}

  ${wrapperOnTablet};
`;

export const PreviewTitle = styled(TitleBlock)`
  margin-bottom: 7px;
  text-align: left;
  padding-left: 19px;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.01em;
    color: #919eaa;
    font-weight: normal;
  }
`;

const centeredOnMobile = media.phone`
  margin: 0 auto;
  display: flex;
`;

export const SaveButtonWrapper = styled.div`
  padding-bottom: 110px;
`;

export const SaveButton = styled(ButtonLoader)`
  min-width: 190px;
  margin-top: 30px;
  ${centeredOnMobile};
`;

const iframeOnMobiles = media.tablet`
  margin-bottom: 20px;
`;

export const LandingFrameWrapper = styled.iframe<LandingFrameWrapperProps>`
  width: 100%;
  display: block;
  border: 0;
  margin: 0 auto;
  ${iframeOnMobiles};

  ${({ iframeHeight }) =>
    iframeHeight &&
    css`
      height: ${iframeHeight}px;
    `}

  ${({ iframeWidth }) =>
    iframeWidth &&
    css`
      width: ${iframeWidth}px;
    `}
`;

export const StickyWrapper = styled.div<{ isMobilePreview?: boolean }>`
  position: sticky;
  top: 70px;
  transform-origin: 0 0;
  ${({ isMobilePreview }) =>
    isMobilePreview &&
    !isMobileOrIPad() &&
    css`
      padding: 70px 0;
    `}
`;

export const BlockedVideoWrapper = styled.div<Partial<VideoSizes>>`
  ${playerContainerCommonStyles};
  display: flex;
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  background: #ebeef5;
  padding: 0 110px;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  text-align: center;
  color: #919eaa;

  p {
    margin: auto;
  }

  a {
    text-decoration: underline;
    color: inherit;
  }
`;

export default RightPanelWrapper;
